// import { Route, Routes, useLocation } from "react-router-dom";
// import { useEffect } from "react";
// import { updateSEO } from "./utils/seo";
// import HomePage from "./Pages/HomePage";
// import About from "./Pages/About/About";
// import VisionAndMission from "./Pages/About/VisionAndMission";
// import Services from "./Pages/Services/Services";
// import ServiceDetail from "./Pages/Services/ServiceDetail";
// import Doctors from "./Pages/Doctors/Doctors";
// import DoctorDetail from "./Pages/Doctors/DoctorDetail";
// import Appointment from "./Pages/Appointment";
// import Blog from "./Pages/Blogs/Blog";
// import BlogDetail from "./Pages/Blogs/BlogDetail";
// import News from "./Pages/News";
// import Contact from "./Pages/Contact";
// import Ayushman from "./Pages/Ayushman";
// import Career from "./Pages/Career/Career";
// import ApplicationForm from "./Pages/Career/ApplicationForm";
// import NotFound from "./Pages/NotFound";
// import ScrollToTop from "./Components/ScrollToTop";

// const pageSEO = {
//   "/": {
//     title: "Home | Dev Rishi Hospital",
//     description:
//       "Welcome to Dev Rishi Hospital. We provide world-class healthcare services with compassion and advanced medical expertise.",
//     keywords:
//       "Dev Rishi Hospital, home, healthcare, medical services, best hospital, multispecialty hospital",
//   },
//   "/about": {
//     title: "About Us | Dev Rishi Hospital",
//     description:
//       "Learn more about Dev Rishi Hospital, our experienced team of doctors, history, mission, and dedication to patient care.",
//     keywords:
//       "about Dev Rishi Hospital, hospital history, mission, patient care, experienced doctors",
//   },
//   "/vision-mission": {
//     title: "Vision & Mission | Dev Rishi Hospital",
//     description:
//       "Discover the Vision and Mission of Dev Rishi Hospital. We strive for excellence in healthcare and patient satisfaction.",
//     keywords:
//       "vision and mission, hospital vision, healthcare excellence, patient satisfaction",
//   },
//   "/services": {
//     title: "Our Services | Dev Rishi Hospital",
//     description:
//       "Explore the wide range of medical services and specialties provided by Dev Rishi Hospital.",
//     keywords:
//       "medical services, hospital specialties, ICU, OPD, emergency, healthcare services",
//   },
//   "/doctors": {
//     title: "Our Doctors | Dev Rishi Hospital",
//     description:
//       "Meet the expert and dedicated team of doctors at Dev Rishi Hospital, specialized in various medical fields.",
//     keywords:
//       "Dev Rishi Hospital doctors, medical experts, specialists, healthcare professionals",
//   },
//   "/appointment": {
//     title: "Book an Appointment | Dev Rishi Hospital",
//     description:
//       "Book an appointment online with our expert doctors at Dev Rishi Hospital for a consultation.",
//     keywords:
//       "book appointment, doctor consultation, online appointment hospital",
//   },
//   "/contact": {
//     title: "Contact Us | Dev Rishi Hospital",
//     description:
//       "Get in touch with Dev Rishi Hospital. Find our location, contact number, and other essential details for emergency and queries.",
//     keywords:
//       "contact Dev Rishi Hospital, hospital location, emergency phone number, hospital contact",
//   },
//   "/career": {
//     title: "Careers | Dev Rishi Hospital",
//     description:
//       "Join the Dev Rishi Hospital team. Explore our current openings and build a rewarding career in healthcare.",
//     keywords:
//       "hospital jobs, healthcare careers, Dev Rishi Hospital vacancy, medical jobs",
//   },
//   "/ayushman": {
//     title: "Ayushman Bharat | Dev Rishi Hospital",
//     description:
//       "Dev Rishi Hospital is empanelled under Ayushman Bharat. Avail cashless treatment and quality healthcare.",
//     keywords: "Ayushman Bharat, cashless treatment, PMJAY, Ayushman hospital",
//   },
//   "/blog": {
//     title: "Health Blogs | Dev Rishi Hospital",
//     description:
//       "Read the latest health tips, medical updates, and informative articles written by experts at Dev Rishi Hospital.",
//     keywords: "health blogs, medical articles, health tips, wellness",
//   },
//   "/news": {
//     title: "News & Events | Dev Rishi Hospital",
//     description:
//       "Stay updated with the latest news, announcements, and events at Dev Rishi Hospital.",
//     keywords: "hospital news, medical events, Dev Rishi Hospital updates",
//   },
  
// };

// function App() {
//   const location = useLocation();

//   useEffect(() => {
//     const seo = pageSEO[location.pathname];
//     // console.log(location.pathname)
//     if (seo) {
//       updateSEO(seo);
//     } else if (location.pathname === "*") {
//       updateSEO({
//         title: "Page Not Found | Dev Rishi Hospital",
//         description: "The page you are looking for does not exist.",
//         keywords: "404, page not found, Dev Rishi Hospital",
//       });
//     }
//     // Note: Detail pages (Service, Doctor, Blog) handle their own SEO updates
//     // as they need to wait for data to be fetched by slug.
//   }, [location]);

//   return (
//     <>
//       <ScrollToTop />
//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/vision-mission" element={<VisionAndMission />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/service-detail/:slug" element={<ServiceDetail />} />
//         <Route path="/doctors" element={<Doctors />} />
//         <Route path="/doctor-detail/:slug" element={<DoctorDetail />} />
//         <Route path="/appointment" element={<Appointment />} />
//         <Route path="/blog" element={<Blog />} />
//         <Route path="/blog-detail/:slug" element={<BlogDetail />} />
//         <Route path="/news" element={<News />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/ayushman" element={<Ayushman />} />
//         <Route path="/career" element={<Career />} />
//         <Route path="/apply/:jobId" element={<ApplicationForm />} />
//         <Route path="*" element={<NotFound />} />
//       </Routes>
//     </>
//   );
// }

// export default App;




import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import About from "./Pages/About/About";
import VisionAndMission from "./Pages/About/VisionAndMission";
import Services from "./Pages/Services/Services";
import ServiceDetail from "./Pages/Services/ServiceDetail";
import Doctors from "./Pages/Doctors/Doctors";
import DoctorDetail from "./Pages/Doctors/DoctorDetail";
import Appointment from "./Pages/Appointment";
import Blog from "./Pages/Blogs/Blog";
import BlogDetail from "./Pages/Blogs/BlogDetail";
import News from "./Pages/News";
import Contact from "./Pages/Contact";
import Ayushman from "./Pages/Ayushman";
import Career from "./Pages/Career/Career";
import ApplicationForm from "./Pages/Career/ApplicationForm";
import NotFound from "./Pages/NotFound";
import ScrollToTop from "./Components/ScrollToTop";
import SEOHead from "./Components/SEOHead";
import { pageSEO } from "./utils/seo";
import { BACKEND_URL } from "./api";

const SitemapRedirect = () => {
  useEffect(() => {
    const target = `${BACKEND_URL.replace(/\/+$/, '')}/sitemap.xml`;
    if (typeof window !== "undefined") {
      window.location.replace(target);
    }
  }, []);
  return null;
};

const RobotsRedirect = () => {
  useEffect(() => {
    const target = `${BACKEND_URL.replace(/\/+$/, '')}/robots.txt`;
    if (typeof window !== "undefined") {
      window.location.replace(target);
    }
  }, []);
  return null;
};

// Route path -> pageSEO key (existing data reuse hi hai, sirf mapping)
const routeSEOKey = {
  "/": "home",
  "/about": "about",
  "/vision-mission": "visionMission",
  "/services": "services",
  "/doctors": "doctors",
  "/appointment": "appointment",
  "/contact": "contact",
  "/career": "career",
  "/ayushman": "ayushman",
  "/blog": "blogs",
  "/news": "news",
};

function App() {
  const location = useLocation();
  const seoKey = routeSEOKey[location.pathname];
  const staticSEO = seoKey
    ? pageSEO[seoKey]
    : location.pathname.startsWith("/apply/")
    ? pageSEO.career
    : pageSEO.notFound;

  return (
    <>
      {/* Fallback SEO — dynamic detail pages (service/doctor/blog) apna khud ka
          <SEOHead> render karke ise override kar dete hain */}
      <SEOHead
        {...staticSEO}
        url={`https://devrishihospital.com${location.pathname}`}
        schema={location.pathname === "/" ? {
          "@context": "https://schema.org",
          "@type": "Hospital",
          "name": "Dev Rishi Hospital",
          "url": "https://devrishihospital.com",
          "description": "Dev Rishi Hospital - Providing world-class healthcare services with compassion and expertise."
        } : null}
      />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/vision-mission" element={<VisionAndMission />} />
        <Route path="/services" element={<Services />} />
        <Route path="/service-detail/:slug" element={<ServiceDetail />} />
        <Route path="/doctors" element={<Doctors />} />
        <Route path="/doctor-detail/:slug" element={<DoctorDetail />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-detail/:slug" element={<BlogDetail />} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ayushman" element={<Ayushman />} />
        <Route path="/career" element={<Career />} />
        <Route path="/apply/:jobId" element={<ApplicationForm />} />
        <Route path="/sitemap.xml" element={<SitemapRedirect />} />
        <Route path="/sitemap" element={<SitemapRedirect />} />
        <Route path="/robots.txt" element={<RobotsRedirect />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;